import React from 'react';
import { useConfig } from '../context/ConfigContext';
import { formatStatus } from '../services/jobService'; // Use existing formatter as fallback

// Define a mapping from config color names to Tailwind CSS classes
const colorMap = {
    green: 'bg-green-100 text-green-800',
    blue: 'bg-blue-100 text-blue-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    cyan: 'bg-cyan-100 text-cyan-800',
    red: 'bg-red-100 text-red-800',
    orange: 'bg-orange-100 text-orange-800',
    gold: 'bg-yellow-300 text-yellow-800',
    default: 'bg-gray-100 text-gray-800',
};

const StatusBadge = ({ statusCode }) => {
    const { statuses } = useConfig();

    // Find the status object from config
    const statusInfo = statuses.find(s => s.code === statusCode);

    // Determine display text and color classes
    const displayText = statusInfo ? statusInfo.display : formatStatus(statusCode || 'N/A'); // Use display name or fallback
    const colorClasses = statusInfo?.color && colorMap[statusInfo.color.toLowerCase()]
        ? colorMap[statusInfo.color.toLowerCase()]
        : colorMap.default;

    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClasses}`}
        >
            {displayText}
        </span>
    );
};

export default StatusBadge;
